const Footer = () => {
    return (
        <div className="footer-container">
            <div className="container-fuid">
                <div className="row">
                    <div className="col-md-4"></div>

                    <div className="col-md-4 footer-content">
                        <img src="/gov_brands.png" className="brand-image-footer" />
                    </div>

                    <div className="col-md-4"></div>
                </div>
            </div>
        </div>
    );
};

export default Footer;